export class ObjectUtils {
  public static omitUndefined = (object: Record<any, any>) => {
    Object.keys(object).forEach((key) => {
      if (object[key] && typeof object[key] === 'object') {
        ObjectUtils.omitUndefined(object[key])
      } else if (object[key] === undefined) {
        delete object[key]
      }
    })

    return object
  }

  /**
   * Converts object into query string.
   * @param object
   */
  public static convertObjToQueryString(object: object): string {
    const str = []
    for (const [key, value] of Object.entries(object)) {
      if (value) {
        str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
      }
    }
    return str.join('&')
  }

  /**
   * Converts a JS object to a FormData object.
   * @param object The JS object that will be converted to a FormData object.
   */
  public static convertObjToFormData(object: object): FormData {
    const formData = new FormData()
    for (const [key, value] of Object.entries(object)) {
      formData.append(key, value)
    }
    return formData
  }
}
